import React from "react";
import PropTypes from "prop-types";
import "../styles/LoadingSpinner.css";

/**
 * Reusable SVG spinner that mirrors the Card View loading indicator.
 *
 * @param {Object} props
 * @param {"sm"|"md"|"lg"} [props.size="md"] - Visual size of the spinner.
 * @param {string|null} [props.label="Loading…"] - Optional accessible label displayed under the spinner.
 * @param {string} [props.className] - Optional additional class names.
 */
const LoadingSpinner = ({ size = "md", label = "Loading…", className = "" }) => {
  const classes = ["loading-spinner", `loading-spinner--${size}`];
  if (className) classes.push(className);

  return (
    <div className={classes.join(" ")} role="status" aria-live="polite">
      <svg className="loading-spinner__icon" viewBox="0 0 50 50">
        <circle
          className="loading-spinner__path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
        />
      </svg>
      {label ? <span className="loading-spinner__label">{label}</span> : null}
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  className: PropTypes.string,
};

export default LoadingSpinner;
